var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-loader',{attrs:{"view-box":"0 0 430 80","speed":2,"primary-color":"#f3f3f3","secondary-color":"#ecebeb"}},[_c('circle',{attrs:{"cx":"200","cy":"32","r":"32"}}),_c('circle',{attrs:{"cx":"224","cy":"49","r":"7"}})])}
var staticRenderFns = []

export { render, staticRenderFns }